
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(27, 54, 93, 0.8), rgba(43, 182, 163, 0.8)), url('https://static.readdy.ai/image/f3375ab72d7f65b358dc6cf884e758f7/aee3663cd56fcccaaeb71b0841b15207.png')`
      }}
    >
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
            Build Predictable Revenue Systems That Scale Beyond You
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-2xl">
            Stop the feast-or-famine cycle. We help service-based companies build AI-powered revenue systems that generate consistent growth without founder dependency.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/book-call">
              <Button 
                variant="primary" 
                size="large"
                className="bg-[#2BB6A3] hover:bg-[#2BB6A3]/90 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Book Free Strategy Call
              </Button>
            </Link>
            <Link to="/free-assessment">
              <Button 
                variant="secondary" 
                size="large"
                className="border-2 border-white text-white hover:bg-white hover:text-[#1B365D] px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Get Free Assessment
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
